export const state = {
  thirdPartyPayments: [],
  isLoading: false,
};
